import {buildDescriptorControl} from "../descriptorcontrols/ControlResolver";

export default (props) => buildDescriptorControl("StringField", "label", props);



// WEBPACK FOOTER //
// ./app/lib/common/controls/Label.js